import AppService from "./app-service"

export default class SrvService extends AppService {

  constructor() {
    super({ path: "services" })
  }

  static get TYPE_ICONS() {
    return {
      normal: { icon: "file alternate icon", description: "Normal" },
      return: { icon: "undo blue icon", description: "Controle" },
      duty: { icon: "calendar check outline red icon", description: "Plantão" },
      others: { icon: "circle outline teal icon", description: "Outros" },
    }
  }

  canRemoveServiceType(id) {
    return this.http.get(`can-remove-service-type/${id}`).then((response) => response.canRemove)
  }
}